module.exports = __webpack_public_path__ + "static/img/8.821aba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/8.png
// module id = X+6w
// module chunks = 0